"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setStateProps = exports.getStep = exports.setInitData = void 0;
var React = require("react");
var step1_1 = require("../steps/step1");
var step2_1 = require("../steps/step2");
var step_consents_1 = require("../steps/step_consents");
var languages_1 = require("utils/helpers/languages");
var isSsoUser = function (currentUser) {
    return currentUser.map(function (_a) {
        var company = _a.company;
        return !company || company.length === 0;
    });
};
var getUserLanguage = function (userLanguage) {
    return !!userLanguage ? languages_1.languageData.find(function (_a) {
        var code = _a.code;
        return userLanguage === code;
    }) : null;
};
var setInitData = function (user, props) {
    var _a;
    var userLanguage = user.language && !props.auth.login.firstTime
        ? user.language
        : (_a = props.match) === null || _a === void 0 ? void 0 : _a.params.language;
    props.updateField('firstName')(user.firstName || '');
    props.updateField('lastName')(user.lastName || '');
    props.updateField('language')(userLanguage || 'en');
    props.selectUserAvatar(user.avatar || '');
    props.updateField('telephone')(user.addressDetails.telephone || '');
    props.updateField('street')(user.addressDetails.street || '');
    props.updateField('postalCode')(user.addressDetails.postalCode || '');
    props.updateField('city')(user.addressDetails.city || '');
    props.updateField('country')(user.addressDetails.country || '');
    props.updateField('title')(user.addressDetails.title || '');
};
exports.setInitData = setInitData;
var getStep = function (props) { return ({
    0: React.createElement(step1_1.default, props),
    1: React.createElement(step2_1.default, props),
    2: React.createElement(step_consents_1.StepConsents, props)
}); };
exports.getStep = getStep;
var setStateProps = function (firstLogin, auth, currentUser, userLanguage) { return ({
    firstLogin: firstLogin,
    auth: auth,
    isSsoUser: isSsoUser(currentUser),
    language: getUserLanguage(userLanguage)
}); };
exports.setStateProps = setStateProps;
